.LinkHistoryList {
  padding: 2rem 0 10rem;
}
